import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Images from '../../utils/Images';
import { useNavigate, useParams } from 'react-router-dom';
import gsap from 'gsap';
import { API } from '../../utils/Api';
import axios from 'axios';

const SplashScreen = () => {
  const navigate = useNavigate();
  const logoRef = useRef(null);
  const token = localStorage.getItem('token');
  const [advertisement, setAdvertisement] = useState('sdjknkjsfnvkjn');

  const params = useParams();
  const referralId = params['referId'];

  const getAdvertisement = async () => {
    try {
      const response = await axios.get(
        `${API.BASE_URL}in-app-advertisement/getSplashScreenAd`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setAdvertisement(response?.data?.data?.inAppAdvertisement?.advertisementImageUrl);
      console.log('response?.data?.data?.inAppAdvertisement?.advertismentImageUrl', response?.data?.data?.inAppAdvertisement?.advertisementImageUrl);
    } catch (error) {
      console.error('Error in fetching advertisement', error);
      setAdvertisement(null);
    }
  };

  useEffect(() => {
    getAdvertisement();
  }, []);

  useEffect(() => {
    if (referralId) {
      localStorage.setItem('referralId', referralId);
      console.log('Referral ID stored in localStorage:', referralId);
    }
  }, [referralId]);

  useEffect(() => {
    const logo = logoRef.current;

    gsap.fromTo(
      logo,
      { scale: 0.8 },
      {
        scale: 1.2,
        duration: 1.2,
        ease: 'bounce.out',
        onComplete: () => {
          gsap.to(logo, { scale: 1.2, duration: 0.5 });
        }
      }
    );

    const timer = setTimeout(() => {
      navigate('/xpanse-advertise', {
        state: { advertisement },
        replace: true
      });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, advertisement]);

  return (
    <Box className="splashScreen">
      <img ref={logoRef} className="splashLogo" src={Images.xpanseSplashLogo} alt="Logo" />
      {/* <img className="img-fluid cloudR1" style={{ filter: 'invert(1)' }} src={Images.cloudR1} alt="cloud" />
      <img className="img-fluid cloudR2" style={{ filter: 'invert(1)' }} src={Images.cloudR2} alt="cloud" />
      <img className="img-fluid cloudL1" style={{ filter: 'invert(1)' }} src={Images.cloudL1} alt="cloud" />
      <img className="img-fluid cloudL2" style={{ filter: 'invert(1)' }} src={Images.cloudL2} alt="cloud" /> */}
    </Box>
  );
};

export default SplashScreen;